export interface ICountry {
  numeric: string;
  alpha2: string;
  alpha3: string;
  name: string;
  continent: string;
}
